module.exports = __webpack_public_path__ + "assets/img/file.5c795c25.svg";